/**
 * Plans Disclaimer Component
 * Displays legal disclaimer for architectural plans, renderings, and illustrative materials
 * 
 * This component should be displayed near all unit depictions to meet legal requirements
 * while maintaining a professional, non-intrusive user experience.
 */

interface PlansDisclaimerProps {
  /** Additional CSS classes for customization */
  className?: string;
}

export const PlansDisclaimer = ({ className = '' }: PlansDisclaimerProps) => {
  return (
    <div
      className={`text-xs sm:text-sm text-muted-foreground leading-relaxed pt-3 mt-4 border-t border-border/50 ${className}`}
      role="note"
      aria-label="Legal disclaimer for architectural plans and renderings"
    >
      <p>
        The architectural plans, renderings, graphic images, and any other illustrative materials ("Plans and Images") displayed on this website are intended for marketing and representational purposes only. They are not intended to be, and should not be construed as, the final, definitive plans for construction.
      </p>
    </div>
  );
};
